import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { getMenuQuery } from '../helpers/navigation'

const findMenuById = (menus, menuId) => menus?.find((menu) => menu?._id?.toString() === menuId?.toString())

const withSelectedMenu = (BaseComponent) => (props) => {
	const { data } = props
	const { menus } = data ? data : {}
	const { Menu } = useSelector((state) => ({ Menu: state?.Menu }))
	const location = useLocation()
	const { menuId: menuIdFromUrl } = getMenuQuery(location?.search)

	const matchMenuId = useRouteMatch('/menu/:id')
	const matchOrderId = useRouteMatch('/order/:id')
	const match = matchMenuId || matchOrderId
	const isMenuOrOrderRoute = Boolean(match)

	const matchMenuMap = useRouteMatch('/menu/:restaurantId/:mapId')
	const matchOrderMap = useRouteMatch('/order/:restaurantId/:mapId')
	const matchMap = matchMenuMap || matchOrderMap

	const [menuIndex, setMenuIndex] = useState(0)
	const [selectedMenu, setSelectedMenu] = useState(null)
	const [restaurantID, setRestaurantID] = useState(null)

	useEffect(() => {
		if (selectedMenu && typeof menus === 'object') {
			const index = menus.findIndex((menu) => menu?._id === selectedMenu?._id)
			setMenuIndex(index)
		}
		// eslint-disable-next-line
	}, [selectedMenu, menus])

	useEffect(() => {
		if (selectedMenu) {
			document.title = selectedMenu?.name
		}
	}, [selectedMenu])

	useEffect(() => {
		if (match?.params?.id) {
			if (match.params.id !== restaurantID) {
				setRestaurantID(match.params.id)
				setSelectedMenu(null)
			}
		}

		if (matchMap?.params?.restaurantId) {
			if (matchMap.params.restaurantId !== restaurantID) {
				setRestaurantID(matchMap.params.restaurantId)
				setSelectedMenu(null)
			}
		}

		// eslint-disable-next-line
	}, [match, matchMap])

	useEffect(() => {
		if (!restaurantID || !data?.menus?.length) return

		const menuFromUrl = findMenuById(data.menus, menuIdFromUrl)
		if (menuFromUrl) {
			setSelectedMenu(menuFromUrl)
		} else if (data.menus.length === 1) {
			setSelectedMenu(data.menus[0])
		}
		// eslint-disable-next-line
	}, [restaurantID, data, menuIdFromUrl])

	useEffect(() => {
		if (!isMenuOrOrderRoute || menuIdFromUrl) return
		if (Menu?.selected?._id && findMenuById(data?.menus, Menu.selected._id)) {
			setSelectedMenu(Menu.selected)
		}
		// eslint-disable-next-line
	}, [Menu?.selected, isMenuOrOrderRoute, data, menuIdFromUrl])

	return <BaseComponent {...props} selectedMenu={selectedMenu} index={menuIndex} setSelectedMenu={setSelectedMenu} />
}

export default withSelectedMenu
